
/// 軽減税率の商品名に付加する文字列
export const REDUCED_TAX_PREFIX = "[軽] ： ";

/// 発注ステータスリスト（コンボボックスアイテム）
export const PURCHASE_STATUS_LIST = [
    { statusCode: ['20', '20K'], statusName: '発注済' },
    { statusCode: ['21K'], statusName: '構成データ待ち' },
    { statusCode: ['22K'], statusName: '構成データ確認待ち' },
    { statusCode: ['30'], statusName: '発注確認済' },
    { statusCode: ['30K'], statusName: '構成データ確認済み' },
    { statusCode: ['40', '40K', '50', '50K'], statusName: '納品済' },
    { statusCode: '60', statusName: '請求未確定' },
    { statusCode: '70', statusName: '請求済' },
] as const;

/// 表示件数リスト（コンボボックスアイテム）
export const PAGE_LENGTH_LIST = [
    { pageLength: 10, pageLabel: '10件' },
    { pageLength: 50, pageLabel: '50件' },
    { pageLength: 100, pageLabel: '100件' },
] as const;

export const ERROR_NEW_PASSWORD  = "新しいパスワードを入力してください。";
export const ERROR_DISSONANCE    = "パスワードが一致しません。";
export const ERROR_NOT_CONDITION = "文字が不正です。英数字を組み合わせてください";

/// 発注先請求書PDFファイル名
//export const INVOICE_PDF_FILENAME = "InvoicePdf0001.pdf";
//export const INVOICE_CSV_FILENAME = "InvoiceCsv0001.csv";
export const MONTHLY_INVOICE_FILENAME = "MonthlyInvoice_";
